import module from 'module';
import ParameterizedLocalCache from 'shared/util/parameterized-local-cache';

module.factory('productCache', (http, CacheFactory, config) =>
  new ParameterizedLocalCache({
    provider: (productId) => http.get(`/products/${productId}`),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.product,
    cacheName: 'productCache'
  })
);
